const commentItems = [
  {
    rating: '4.9',
    text: '"关注五一吃瓜网半年了，真的是全网更新最快最全的吃瓜平台。上次那个顶流塌房事件，其他平台还在传谣言的时候，这里已经放出了完整的时间线和证据链，太专业了！"',
    name: '吃瓜群众小A',
    role: '资深瓜友 · 关注182天',
  },
  {
    rating: '4.8',
    text: '"作为一个自媒体从业者，五一吃瓜网是我每天必刷的信息源。他们的多源验证机制让我可以放心引用，不用担心翻车。而且投稿奖励确实到账很快，推荐给所有有料的瓜友！"',
    name: '娱乐观察员老K',
    role: '自媒体博主 · 关注256天',
  },
  {
    rating: '4.9',
    text: '"从微博追到官网再追到APP，五一吃瓜网的内容质量一直很稳定。最让我佩服的是他们的更新速度，有时候半夜三点还在发爆料，真的是24小时不停歇。吃瓜人就该有这种精神！"',
    name: '熬夜吃瓜专业户',
    role: '忠实用户 · 关注403天',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-20 md:py-28 bg-background-400">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground-950 text-center mb-16">
          瓜友热评：最新读者评论
        </h2>

        <div className="flex flex-col gap-12">
          {commentItems.map((item, idx) => (
            <div key={idx} className="relative">
              <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-xs font-bold mb-4">
                ⭐ {item.rating}
              </span>

              <blockquote className="font-serif text-base md:text-lg text-foreground-700 leading-relaxed italic">
                {item.text}
              </blockquote>

              <div className="mt-5 flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-foreground-800/10 flex items-center justify-center">
                  <span className="text-lg font-bold text-foreground-500 font-heading">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center gap-3">
          <button className="w-10 h-10 rounded-lg bg-background-700 border border-foreground-800/20 flex items-center justify-center text-foreground-600 hover:text-accent-800 hover:border-accent-500 transition-all duration-200 cursor-pointer">
            <i className="ri-arrow-left-line"></i>
          </button>
          <button className="w-10 h-10 rounded-lg bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all duration-200 cursor-pointer">
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}